import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

export const styles = {
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 2,
    paddingTop: '16px',
    paddingBottom: '24px',
  },
  headerFont: {
    fontSize: 18,
    fontWeight: 600,
  },
  filterContainer: {
    mb: 1,
  },
  title: {
    fontWeight: 600,
    fontSize: 22,
    color: 'common.grey850',
  },
  headerContainer: {
    mb: 2,
  },
} satisfies Record<string, SxProps<Theme>>;
